import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { flushGpsQueueToServer, checkShiftTimeout, resumeShiftTracking } from '../services/shiftTrackingService';
import { sincronizarJornadas } from '../services/jornadaOfflineService';
import { sincronizarAvisos, contextoAsistencia } from '../services/asistenciaOfflineService';

/**
 * Hook para monitorear el estado de jornada en la aplicación y sincronizar
 * la cola de puntos GPS pendientes cuando hay red.
 * REGLA DE NEGOCIO: Estar autenticado NO activa el tracking por sí solo.
 */
export function useGpsTracking() {
    const { status, user } = useAuth();

    useEffect(() => {
        if (status !== 'authenticated' || !user) {
            return;
        }

        const resume = () => {
            checkShiftTimeout();
            void resumeShiftTracking();
            void flushGpsQueueToServer().catch((error) => console.warn('[GPS] Sincronización pendiente:', error));
            void sincronizarJornadas().catch(() => {});
            void sincronizarAvisos().catch(() => {});
            void contextoAsistencia().catch(() => {});
        };
        const onVisibility = () => { if (document.visibilityState === 'visible') resume(); };
        resume();
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('online', resume);
        // Reintenta las colas locales: sin cambios no publica eventos ni vuelve a consultar asistencia o historial.
        const syncInterval = setInterval(() => { void sincronizarJornadas().catch(() => {}); void sincronizarAvisos().catch(() => {}); }, 30000);
        const listener = Capacitor.isNativePlatform()
            ? App.addListener('appStateChange', ({ isActive }) => { if (isActive) resume(); })
            : null;

        return () => {
            document.removeEventListener('visibilitychange', onVisibility);
            window.removeEventListener('online', resume);
            clearInterval(syncInterval);
            if (listener) void listener.then((handle) => handle.remove()).catch(() => {});
        };
    }, [status, user?.id]);
}
